import { Dictionary } from '@/util/dictionary';
import { DecoSet } from './decorativeInfos';
import { PlayerType } from './enums';
import { FishType } from './fishInfos';
import { HazardType } from './hazardInfos';
import { ItemCode } from './itemInfos';
import { SkinGroup } from './skinInfos';
import { SpearType } from './spearInfos';

export enum UnlockChallengeType {
	Accumulate,
	OneGame,
	Contribute,
	UnlockFish,
	Level,
	Craft,
	Decorate,
	Mission,
	Gacha,
	Purchase,
	Login,
	NumUnlock,
	NumNewCraft,
	NumCraft,
	NumDeco,
	NumSkins,
	NumSummons,
	LinkEmail,
	EmailVerify,
	LinkPoq,
	UnlockSf1,
	PlaySf1,
	LoginSf1,
}
export enum QuestType {
	Main,
	Weekly,
	TimeLimited,
}

export interface UnlockChallenge {
	type: UnlockChallengeType,
	goal: number,

	unlockId: number,
	isMaster?: boolean,
	step: number,
	index: number,

	description: string,

	material?: ItemCode,
	questType?: QuestType,
}

export type UnlockSteps = UnlockChallenge[][];

export interface UnlockChallengeProgress {
	completed: boolean,
	current: number,
}
export interface QuestProgress {
	currentStep: number,
	progresses: Dictionary<number>,
}
export interface Quest {
	title: string,
	type: QuestType,
	code: number,
	startTime?: number,
	endTime?: number,
	steps: QuestStep[],
	isSf1?: boolean,
}
export interface ItemCodeAmountPair {
	itemCode: ItemCode,
	amount: number,
}
export interface QuestStep {
	rewards: ItemCodeAmountPair[],
	challenges: UnlockChallenge[],
}


export interface UnlockAction {
	sessionId: string,
	uid: string,
	fishType: FishType,
	skin?: SkinGroup,
	currentLife: number,
	finalize: boolean,
	serverName?: string,
	ip?: string,
	name?: string,
	decoSet?: string,
	spearType?: SpearType,
	amgdPlace?: number,
	numAmgdContenders?: number,
	amgdTimeUsed?: number,

	// applied onto self
	killedBy: PlayerType,
	hazardDeathBy: HazardType,
	stabbedBy: Dictionary<number>, // mobLvl : 2
	myStabbedDamageAdd: Dictionary<number>, // mobLvl : 2
	myHazardDamageAdd: Dictionary<number>, // hazardType : 2
	myHazardCountAdd: Dictionary<number>, // hazardType : 2
	myStunCountAdd: number, // 2

	// apply to others
	mined: Dictionary<number>, // oreColor : 2
	stunned: Dictionary<number>, // mobLvl : 2
	stabbed: Dictionary<number>, // mobLvl : 2
	stabDamageAdd: Dictionary<number>, // mobLvl : 2

	killed: Dictionary<Dictionary<number>>, // hazardType: mobLvl: 2

	heal: Dictionary<number>; // healType : 20

	items: Dictionary<number>, // itemCode: 2
	publicChest?: Dictionary<number>, // itemCode: 2

	stunTimeAdd: number,
	boostTimeAdd: number,
	scoreAdd: number,
	scoreSpentAdd: number,
	moneyAdd: number,
	moneySpentAdd: number,

	foodScoreAdd: number,
	foodCount: Dictionary<number>, // foodType: 2,

	whammyh?: number,
	psychokw?: number,
	bottlenoseD?: number,
	commonD?: number,
	spinnerD?: number,
	narwhal?: number,
	puffer?: number,
	porc?: number,
	onifugu?: number,
	leatherback?: number,
	snappingT?: number,
	diamondF?: number,
	blueW?: number,
	dumboO?: number,
	moreel?: number,
	gulpeel?: number,
	eleceel?: number,
	blueray?: number,

	xmas21Bear?: number,
	xmas21Enemy?: number,
	xmas21Team?: number,
	xmas21bpStar?: number,
	xmas21RedN?: number,
	xmas21Rudolph?: number,

	survivalRecord: number,
	stabStreakRecord: number,
	killStreakRecord: number,
	boostTimeRecord: number, // non-stop

	spearEvolves: Dictionary<Dictionary<number>>, // spearType: level: 2
	spearBought?: Dictionary<number>, // spearType: bought

}

export function getEmptyUnlockAction(): UnlockAction {
	return {
		currentLife: 0,
		sessionId: '',
		uid: '',
		fishType: 0,
		finalize: false,

		// applied onto self
		killedBy: 0,
		hazardDeathBy: 0,
		stabbedBy: {}, // mobLvl : 2
		myStabbedDamageAdd: {}, // mobLvl : 2
		myHazardDamageAdd: {}, // hazardType : 2
		myHazardCountAdd: {}, // hazardType : 2
		myStunCountAdd: 0, // 2

		// apply to others
		stunned: {}, // mobLvl : 2
		stabbed: {}, // mobLvl : 2
		stabDamageAdd: {}, // mobLvl : 2
		killed: {}, // hazardType: mobLvl: 2
		mined: {}, // oreColor : 2

		heal: {}, // healType: 20,

		items: {}, // itemCode: 2,

		stunTimeAdd: 0,
		scoreAdd: 0,
		boostTimeAdd: 0,
		scoreSpentAdd: 0,
		moneyAdd: 0,
		moneySpentAdd: 0,

		foodScoreAdd: 0,
		foodCount: {}, // foodType: 2,

		survivalRecord: 0,
		stabStreakRecord: 0,
		killStreakRecord: 0,
		boostTimeRecord: 0, // non-stop

		spearEvolves: {}, // spearType: level: 2
	};
}

